import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Clock } from 'lucide-react';
interface ServiceComingSoonProps {
  serviceName: string;
  icon?: React.ReactNode;
}
export function ServiceComingSoon({
  serviceName,
  icon
}: ServiceComingSoonProps) {
  return <div className="flex flex-col w-full min-h-[600px]" data-id="element-344">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-345">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-346">
          <div className="flex justify-center mb-6" data-id="element-347">
            {icon || <Clock className="w-16 h-16 text-white" data-id="element-348" />}
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-349">
            {serviceName}
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-350">
            Detailed information about this service is coming soon
          </p>
        </div>
      </section>

      {/* Coming Soon Content */}
      <section className="py-20 bg-white flex-grow flex items-center" data-id="element-351">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-352">
          <div className="bg-gray-50 rounded-2xl p-12 border border-gray-100" data-id="element-353">
            <Clock className="w-20 h-20 text-wh-pink mx-auto mb-6" data-id="element-354" />
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-355">
              Content Coming Soon
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-356">
              We're working on creating detailed information about our{' '}
              {serviceName.toLowerCase()} services. In the meantime, feel free
              to contact us directly to learn more about how we can help with
              your project.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-357">
              <Button variant="primary" size="lg" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-359" />} data-id="element-358">
                Contact Us
              </Button>
              <Button variant="outline" size="lg" data-id="element-360">
                View All Services
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
}